import { Box, List } from '@mui/material'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { AppRoutesNavigation } from '../../app-routes'
import { SidebarHeaderItem } from '../../components/SidebarHeaderItem'
import { SidebarItem } from '../../components/SidebarItem'
import { filterNavItemsByAppFeatures } from 'src/helpers/filterNavByAppFeatures'
import { useFeatureFlagsCtx, useSidebarCtx } from '../../hooks/context-hooks'
import { customerSidebarItems } from './customer-sidebar-items'

import { useGetCustomerById } from 'src/api/customer'
import { permissionValue } from 'src/enums/permissionValue'
import CustomerDropDown from 'src/components/sidemenu/CustomerDropDown'

export const CustomerSidebar = () => {
  const { id } = useParams<any>()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { t: translate } = useTranslation(['admin-sidebar', 'service'])
  const { setCollapsibleSidebarOpen, collapsibleSidebarOpen } = useSidebarCtx()
  const { data: customerInfo } = useGetCustomerById(id as EntityId)
  const { isIntegrationEnabled } = useFeatureFlagsCtx()
  const sidebarItems = filterNavItemsByAppFeatures(
    customerSidebarItems(Boolean(customerInfo?.isGlobalServiceStationProvider)),
    isIntegrationEnabled,
  )

  useEffect(() => {
    setCollapsibleSidebarOpen(true)
  }, [])

  useEffect(() => {
    if (customerInfo) {
      if (
        (BigInt(customerInfo?.permission) & BigInt(permissionValue.ClientAdminPortal.Equipment_Portal)) ==
        BigInt(permissionValue.ClientAdminPortal.Equipment_Portal)
      ) {
        navigate(AppRoutesNavigation.Customer.mainComponents(id as EntityId))
      } else if (
        (BigInt(customerInfo?.permission) & BigInt(permissionValue.ClientAdminPortal.Task_Portal)) ==
        BigInt(permissionValue.ClientAdminPortal.Task_Portal)
      ) {
        navigate(AppRoutesNavigation.Customer.workOrders(id as EntityId))
      }
    }
  }, [customerInfo])

  return (
    <Box sx={{ paddingTop: '0px' }}>
      <Box padding={'8px'}>
        <CustomerDropDown />
      </Box>
      <List
        style={{ width: collapsibleSidebarOpen ? '100%' : '72px', height: window.innerHeight - 180, overflow: 'auto' }}
        className="!px-1 !py-1 lg:!pl-1"
      >
        {sidebarItems.map(
          item => {
            const isHeader = item?.children && item.children?.length > 0
            if (
              item.permissions &&
              (customerInfo?.permission == null ||
                customerInfo?.permission <= 0 ||
                !hasPermission(item.permissions, customerInfo?.permission || 0))
            ) {
              return null
            }
            return (
              <div key={item.name}>
                {isHeader && (
                  <SidebarHeaderItem
                    item={item}
                    textVisibility={collapsibleSidebarOpen}
                    title={item.name}
                    Icon={item.icon}
                    id={id}
                    pathname={pathname}
                    isCollapsed={collapsibleSidebarOpen}
                  />
                )}
                {!isHeader && (
                  <SidebarItem
                    key={item.name}
                    active={!!pathname && pathname.split('/')[4] === item.pathname}
                    title={translate(item.name)}
                    Icon={item.icon}
                    textVisibility={collapsibleSidebarOpen}
                    onClick={() => navigate(item.path ? item.path(id!) : AppRoutesNavigation.Home)}
                  />
                )}
              </div>
            )
          })}
      </List>
    </Box>
  )
}

const hasPermission = (permissions: number[], permissionValue: number) => {
  return permissions.some(permission => (BigInt(permission) & BigInt(permissionValue)) == BigInt(permission))
}
